import { StateCreator } from 'zustand';

export interface ChatSlice {
    threadId: string | null;
    setThreadId: (threadId: string) => void;
    clearThread: () => void;
}

const initialChatState = {
    threadId: null
};

export const createChatSlice: StateCreator<ChatSlice> = (set, get) => ({
    ...initialChatState,
    setThreadId: (threadId: string) => {
        set({ threadId: threadId });
    },
    clearThread: () => {
        set({ threadId: null });
    }
});
